import "./utils";

import("./components/layout/smooth-scroll").catch((error) => {
  console.error("Failed to load SmoothScroll module:", error);
});

if (document.querySelector("[data-header]")) {
  import("./components/layout/header").catch((error) => {
    console.error("Failed to load Header module:", error);
  });
}

if (document.querySelector("[data-scroll-top]")) {
  import("./components/layout/scroll-to-top").catch((error) => {
    console.error("Failed to load ScrollToTop module:", error);
  });
}

if (document.querySelector(".swiper")) {
  import("./swipers/main").catch((error) => {
    console.error("Failed to load Swiper module:", error);
  });
}
if (document.querySelector(".backdrop")) {
  import("./popups/main").catch((error) => {
    console.error("Failed to load Popups module:", error);
  });
}

if (document.querySelector("[data-peptides]")) {
  import("./components/home/peptides").catch((error) => {
    console.error("Failed to load Peptides module:", error);
  });
}

if (document.querySelector("[data-training-slider]")) {
  import("./components/home/training-program").catch((error) => {
    console.error("Failed to load TrainingProgram module:", error);
  });
}

if (document.querySelector("[data-learning-outcomes]")) {
  import("./components/home/learning-outcomes").catch((error) => {
    console.error("Failed to load LearningOutcomes module:", error);
  });
}

if (document.querySelector("[data-doctors-reviews]")) {
  import("./components/home/doctors-reviews").catch((error) => {
    console.error("Failed to load DoctorsReviews module:", error);
  });
}

import "../css/main.scss";
